module.exports = __webpack_public_path__ + "img/oxymeter_primary.dc882160.svg";